<template>
  <div class="app-layout">
    <NavbarView  
      v-if="showNavbar" 
      class="sidebar-desktop" 
    />

    <MobileNavbar 
      v-if="showNavbar"
      class="navbar-mobile"
    />
   
    <main class="main-content">
      <router-view />
    </main>
  </div>
</template>

<script setup>
import { computed } from "vue";
import { useRoute } from "vue-router";
import NavbarView from './components/NavbarView.vue';
import MobileNavbar from "./components/MobileNavbar.vue";

const route = useRoute();

const showNavbar = computed(() => {
  const excludedRoutes = ['/login', '/waitingRoom', '/waitingroom', '/TvPersonalisation'];
  return !excludedRoutes.some(path => route.path.toLowerCase() === path.toLowerCase());
});
</script>

<style scoped>
/* STRUCTURE DE BASE */
.app-layout {
  display: flex;
  height: 100vh;
  width: 100vw;
  overflow: hidden;
  flex-direction: column; /* Par défaut : empilé (Mobile) */
}

.main-content {
  flex: 1;
  overflow-y: auto;
  background-color: #f4f7f9;
}

/* --- LOGIQUE D'AFFICHAGE VIA MEDIA QUERIES --- */

/* 1. État MOBILE (par défaut pour écrans < 768px) */
@media (max-width: 767px) {
  .sidebar-desktop {
    display: none !important;
  }
  
  .navbar-mobile {
    display: block !important; /* Affiche la version mobile */
  }

  .app-layout {
    flex-direction: column; /* Navbar en haut, contenu en bas */
  }
}

/* 2. État DESKTOP (pour écrans >= 768px) */
@media (min-width: 768px) {
  .sidebar-desktop {
    display: flex !important; /* Affiche la sidebar */
  }

  .navbar-mobile {
    display: none !important; /* Cache la version mobile */
  }

  .app-layout {
    flex-direction: row; /* Sidebar à gauche, contenu à droite */
  }
}

/* RESET GLOBAL */
:global(body) {
  margin: 0;
  padding: 0;
  overflow: hidden;
}
</style>